<template>
    <div class="white-bg">
        <top-carousel></top-carousel>
        <div class="abttyou container">
            <div class="weizhi">
                <h2>
                    <i class="product-title"
                        >精品案例&nbsp;&nbsp;&nbsp;&nbsp;BOUTIQUE CASE</i
                    >
                    <span
                        ><a @click="jumpPage('/case')">精品案例</a> &gt;
                        {{ detail.title }}</span
                    >
                </h2>
            </div>
            <div class="abounei">
                <h1>{{ detail.title }}</h1>
                <div>
                    <img :src="detail.url" width="100%" />
                </div>
                <div v-for="item in detail.content" :key="item.label">
                    <h2>{{ item.label }}</h2>
                    <p>
                        {{ item.desc }}
                    </p>
                </div>
                <div class="clearfix">
                    <div class="prev">
                        上一个：
                        <a
                            @click="changeIndex(detail.F_LastId)"
                            v-if="detail.F_LastTitle"
                            >{{ detail.F_LastTitle }}</a
                        >
                        <span v-else>无</span>
                    </div>
                    <div class="next">
                        下一个：
                        <a
                            @click="changeIndex(detail.F_NextId)"
                            v-if="detail.F_NextTitle"
                            >{{ detail.F_NextTitle }}</a
                        >
                        <span v-else>无</span>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 40px"></div>
    </div>
</template>

<script>
import TopCarousel from '../../commonComponents/topCarousel'
export default {
    components: { TopCarousel },
    data() {
        return {
            list: [
                {
                    title: '江华城',
                    url: require('../../../../assets/img/case/jhcd.png'),
                    content: [
                        {
                            label: '项目名称',
                            desc: '江华城',
                        },
                        {
                            label: '合作内容',
                            desc: '机电工程承包，内容锅炉房、制冷站、通风工程、防排烟工程、空调末端系统等机电系统的安装和自动化控制的实施',
                        },
                        {
                            label: '项目特点',
                            desc: '制冷站房采用先进的模糊控制技术，实现制冷系统在部分负荷的情况下COP值达到4.8以上。',
                        },
                    ],
                    id: 'jhc',
                },
                {
                    title: '中牧实业股份有限公司',
                    url: require('../../../../assets/img/case/zmd.jpg'),
                    content: [
                        {
                            label: '项目名称',
                            desc: '中牧实业股份有限公司',
                        },
                        {
                            label: '行业类型',
                            desc: '生物制药行业',
                        },
                        {
                            label: '合作内容',
                            desc: '中牧实业股份有限公司兰州厂二车间自控系统和能源计量系统的建设工作，生物安全三级防护口蹄疫生产车间自控和弱电、P3动物房和智能可视化管理系统的建设工作。',
                        },
                        {
                            label: '项目成果',
                            desc: '中牧实业股份有限公司兰州厂多个车间均符合《兽用疫苗生产企业生物安全三级防护标准》，智能可视化管理系统将各个分离的设备、功能和信息等集成到相互关联、统一协调的系统之中，使资源充分共享，实现集中、高效、便捷的管理。',
                        },
                    ],
                    id: 'zmsy',
                },
                {
                    title: '中农威特生物科技股份有限公司',
                    url: require('../../../../assets/img/case/znd.jpg'),
                    content: [
                        {
                            label: '项目名称',
                            desc: '中农威特生物科技股份有限公司',
                        },
                        {
                            label: '行业类型',
                            desc: '兽用生物制品研发、生产',
                        },
                        {
                            label: '合作内容',
                            desc: '二车间自控系统、智能化系统实施、数字化系统实施。榆中高新区医药基地一期北区安检免疫动物房、效检攻毒动物房智能化系统、数字化系统；动力站、隔离动物房自控系统、智能化系统',
                        },
                        {
                            label: '项目特点',
                            desc: '二车间是第一个按照农业部《兽用疫苗生产企业生物安全三级防护标准》建成并验收通过的灭活疫苗生产车间。定制的数字化系统结合BIM技术和计算机控制技术，对建筑内自控、弱电、消防、工艺系统进行三维建模、渲染和显示，将各系统运行数据实时、动态的与三维模型结合，有效的提高设备管理及系统运维效率。',
                        },
                    ],
                    id: 'znwt',
                },
                {
                    title: '美光半导体',
                    url: require('../../../../assets/img/case/mgd.jpg'),
                    content: [
                        {
                            label: '项目名称',
                            desc: '美光半导体(西安)有限责任公司',
                        },
                        {
                            label: '行业类型',
                            desc: '半导体及元部件相关材料以及相关产品的研发、设计、制造',
                        },
                        {
                            label: '合作内容',
                            desc: '厂务自控系统、弱电系统实施、改造、维修',
                        },
                        {
                            label: '项目特点',
                            desc: '厂务自控系统是对全厂公用设备的自动化控制，其控制内容包括空调风系统、空调水系统、水处理设备、QA实验室、动力站系统，特点是受控设备众多，控制工艺复杂。',
                        },
                    ],
                    id: 'mgbdt',
                },
                {
                    title: '兰州生物制品研究所',
                    url: require('../../../../assets/img/case/lzd.jpg'),
                    content: [
                        {
                            label: '项目名称',
                            desc: '兰州生物制品研究所',
                        },
                        {
                            label: '行业类型',
                            desc: '生物制药行业',
                        },
                        {
                            label: '合作内容',
                            desc: '新建/改造车间空调系统自动化控制、智能化系统、计算机系统验证实施；已运行自控系统维保；数字化运维系统实施；工艺设备控制改造。',
                        },
                        {
                            label: '项目成果',
                            desc: '依据中国及欧盟GMP标准，实现生产车间的温湿度、洁净度、压差梯度的自动化控制。干热灭菌柜的改造解决了原控制系统灭菌周期较长且系统不稳定的问题，增加了上位机，操作人员可远程监控现场运行，降低了频繁进入操作间而造成的灭菌产品受到污染的风险。',
                        },
                    ],
                    id: 'lzsw',
                },
                {
                    title: '智能化系统设计/实施/维保',
                    url: require('../../../../assets/img/case/znhd.jpg'),
                    content: [
                        {
                            label: '项目名称',
                            desc: '御锦城/逸翠园/宝能华府/杨凌展馆D馆',
                        },
                        {
                            label: '行业类型',
                            desc: '房地产/教育',
                        },
                        {
                            label: '合作内容',
                            desc: '闭路电视监控系统，入侵报警系统，巡更系统，门禁系统，楼宇对讲及报警系统，停车场管理系统，背景音乐系统，网络及综合布线。',
                        },
                        {
                            label: '项目成果',
                            desc: '利用现代建筑技术及现代计算机、通信、控制等高新技术，把物业管理、安防、通信等系统集成在一起，并通过通信网络连接物业管理处，为小区住户提供一个安全、舒适、便利的现代生活环境。',
                        },
                    ],
                    id: 'znhxt',
                },
            ],
            detail: {},
            id: this.$route.params.id,
        }
    },
    methods: {
        jumpPage(url) {
            this.$router.push(url)
        },
        getDetailInfo() {
            if (this.id) {
                for (let index = 0; index < this.list.length; index++) {
                    let item = this.list[index]
                    if (item.id == this.id) {
                        this.detail = item
                        let nextIndex = index + 1
                        if (nextIndex < this.list.length) {
                            let nextObj = this.list[nextIndex]
                            this.detail.F_NextTitle = nextObj.title
                            this.detail.F_NextId = nextObj.id
                        } else {
                            this.detail.F_NextTitle = null
                            this.detail.F_NextId = null
                        }
                        let lastIndex = index - 1
                        if (lastIndex > -1) {
                            let lastObj = this.list[lastIndex]
                            this.detail.F_LastTitle = lastObj.title
                            this.detail.F_LastId = lastObj.id
                        } else {
                            this.detail.F_LastTitle = null
                            this.detail.F_LastId = null
                        }
                        break
                    }
                }
            }
        },
        changeIndex(id) {
            this.$router.push('/caseDetail/' + id)
        },
    },
    mounted() {
        this.getDetailInfo()
    },
}
</script>

<style scoped lang="less">
.abttyou {
    border: 1px #e1e0e0 solid;
    margin: 40px auto 20px;
    min-height: 900px;
}
.abttyou .weizhi {
    height: 48px;
    border-bottom: 1px #e1e0e0 solid;
}
.abttyou .weizhi h2 {
    padding: 0 20px;
    font-size: 16px;
    color: rgb(102, 102, 102);
    line-height: 46px;
}
.abttyou .weizhi h2 span {
    float: right;
    color: #999;
}
.abttyou .abounei {
    margin: 30px 25px;
    h1 {
        font-size: 28px;
        text-align: center;
        font-weight: 500;
        margin-bottom: 20px;
    }
}
.abttyou .abounei h2 {
    font-size: 16px;
    font-weight: 800;
    line-height: 48px;
    text-align: left;
}
.abttyou .abounei p {
    font-size: 16px;
    line-height: 30px;
}
.prev {
    float: left;
}
.next {
    float: right;
}
.prev,
.next {
    font-size: 14px;
    margin: 20px 0;
}
</style>
